import React from "react";

export default function Conditions() {
  return (
    <div className="mx-auto max-w-6xl px-4 pt-10">
      <div className="rounded-3xl border border-white/10 bg-white/5 p-6 md:p-10">
        <h1 className="text-2xl font-bold">Conditions of use</h1>
        <p className="mt-4 text-white/70">
          Effective date: January 21, 2026

These Terms and Conditions (“Terms”) govern your use of amrental.eu (the “Website”). By accessing or using the Website, you agree to these Terms.

1. Website operator

AM Rental
Address: Ivan Vazov 38, Floor 3, Sredets District, Sofia, Bulgaria
Phone: +359999991948
Email: support@amrental.eu

2. Purpose of the Website

The Website provides general information about AM Rental and its services. The Website is informational and is provided “as is”.

3. No warranties

We make reasonable efforts to keep the Website content accurate and up to date, but we do not guarantee that:

the information is complete, accurate, or current at all times;

the Website will be uninterrupted or error-free.

To the maximum extent permitted by law, we disclaim all warranties, express or implied, including fitness for a particular purpose and non-infringement.

4. Limitation of liability

To the maximum extent permitted by law, AM Rental shall not be liable for any direct or indirect damages arising from:

your use of, or inability to use, the Website;

reliance on content displayed on the Website;

third-party websites linked from the Website.

Nothing in these Terms limits liability where such limitation is not permitted by applicable law.

5. Intellectual property

All Website content (including text, design, layout, graphics, and logos) is owned by or licensed to AM Rental and is protected by applicable intellectual property laws.

You may view and print pages for personal, non-commercial use. You may not copy, reproduce, republish, distribute, or exploit Website content for commercial purposes without our written permission.

6. Acceptable use

You agree not to:

attempt to gain unauthorized access to the Website or its infrastructure;

disrupt or interfere with Website security or availability;

use the Website in any way that violates applicable laws or regulations.

7. Third-party links

The Website may contain links to third-party websites. We do not control and are not responsible for their content, policies, or practices.

8. Governing law and jurisdiction

These Terms are governed by the laws of Bulgaria. Any disputes arising out of or relating to these Terms or the Website shall be subject to the competent courts in Sofia, Bulgaria, unless mandatory consumer protection rules provide otherwise.

9. Changes to these Terms

We may update these Terms from time to time. The “Effective date” at the top indicates when they were last updated. Continued use of the Website means you accept the updated Terms.

10. Contact

For questions about these Terms, contact: support@amrental.eu
.
        </p>
      </div>
    </div>
  );
}
